import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Order  {
    _originalTypeClassName = "ekylikeio.BO.Order";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Order.translate = translateService;
}
this.DateSections = [];
this.Groups = [];
this.Id = null;
this.Date = null;
this.OrderStatus = null;
this.Notes = null;
this.From = null;
this.To = null;
this.CompletedOn = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Date:any;
OrderStatus:any;
Notes:any;
From:any;
To:any;
CompletedOn:any;
orderToPayment:any;
CreatedBy:any;
DateSections:any;
Groups:any;
static setorderToPayment = ($this, value) => {
var oldValue = $this.orderToPayment;
$this.orderToPayment = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setDateSections = ($this, items) => {
                if (items == null) items = [];
                if ($this.DateSections == null) $this.DateSections = [];

                const copyItems = Common.cloneObject(items);

                while ($this.DateSections.length > 0) {
                    Domain.Order.removeDateSections($this, $this.DateSections[0]);
                }

                Domain.Order.addManyDateSections($this, copyItems);
            }
static addManyDateSections = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Order.addDateSections($this, items[i]);
                }
            }
static addDateSections = ($this, item) => {
                if ($this.DateSections == null) $this.DateSections = [];
                if (item == null || $this.DateSections.indexOf(item) > -1) return;
                $this.DateSections.push(item);
if (item.Order != $this) {
Domain.OrderDateSection.setOrder(item, $this);
}
}
static addRangeDateSections = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Order.addDateSections($this, item));
            }
static removeDateSections = ($this, item) => {
                if ($this == null || $this.DateSections == null || $this.DateSections.indexOf(item) === -1) return;
                var _index = $this.DateSections.indexOf(item);
                $this.DateSections.splice(_index, 1);
item.Order = null;
}
static clearDateSections = ($this) => { $this.DateSections = null; }
static setGroups = ($this, items) => {
                if (items == null) items = [];
                if ($this.Groups == null) $this.Groups = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Groups.length > 0) {
                    Domain.Order.removeGroups($this, $this.Groups[0]);
                }

                Domain.Order.addManyGroups($this, copyItems);
            }
static addManyGroups = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Order.addGroups($this, items[i]);
                }
            }
static addGroups = ($this, item) => {
                if ($this.Groups == null) $this.Groups = [];
                if (item == null || $this.Groups.indexOf(item) > -1) return;
                $this.Groups.push(item);
}
static addRangeGroups = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Order.addGroups($this, item));
            }
static removeGroups = ($this, item) => {
                if ($this == null || $this.Groups == null || $this.Groups.indexOf(item) === -1) return;
                var _index = $this.Groups.indexOf(item);
                $this.Groups.splice(_index, 1);
}
static clearGroups = ($this) => { $this.Groups = null; }

static CreateDTO($this: any): any{let groups = [];
for (let _idateSection = 0; _idateSection < ($this?.DateSections?.linq?.orderBy((d) => d?.Date)?.toArray() == null ? 0 : $this?.DateSections?.linq?.orderBy((d) => d?.Date)?.toArray().length); _idateSection++) {let dateSection = $this?.DateSections?.linq?.orderBy((d) => d?.Date)?.toArray()[_idateSection];for (let _istudentSection = 0; _istudentSection < (dateSection?.StudentSections?.linq?.orderBy((o) => o?.Student?.FullName)?.toArray() == null ? 0 : dateSection?.StudentSections?.linq?.orderBy((o) => o?.Student?.FullName)?.toArray().length); _istudentSection++) {let studentSection = dateSection?.StudentSections?.linq?.orderBy((o) => o?.Student?.FullName)?.toArray()[_istudentSection];let group = groups?.linq?.where((g) => g?.Student == studentSection?.Student)?.firstOrDefault(null);if (group == null) {group = new Domain.OrderGroupDTO();Domain.OrderGroupDTO.setStudent(group, studentSection?.Student);groups?.add(group);}let dateGroup = group?.DateGroups?.linq?.where((d) => (new Date(d?.Date).getTime()) == (new Date(dateSection?.Date).getTime()))?.firstOrDefault(null);if (dateGroup == null) {dateGroup = new Domain.OrderDateGroupDTO();dateGroup.Date = dateSection?.Date;group?.DateGroups?.add(dateGroup);}for (let _iitemSection = 0; _iitemSection < (studentSection?.Items == null ? 0 : studentSection?.Items.length); _iitemSection++) {let itemSection = studentSection?.Items[_iitemSection];let item = new Domain.OrderGroupItemDTO();Domain.OrderGroupItemDTO.setSchoolBreak(item, itemSection?.PickupAt);Domain.OrderGroupItemDTO.setMenuItem(item, itemSection?.MenuItem);item.Quantity = itemSection?.Quantity;item.TotalPrice = itemSection?.TotalPrice;item.OriginalId = itemSection?.Id;dateGroup?.Items?.add(item);}}}
for (let _igroup = 0; _igroup < (groups == null ? 0 : groups.length); _igroup++) {let group = groups[_igroup];for (let _idGroup = 0; _idGroup < (group?.DateGroups == null ? 0 : group?.DateGroups.length); _idGroup++) {let dGroup = group?.DateGroups[_idGroup];dGroup.TotalPrice = dGroup?.Items?.linq?.sum((s) => s?.TotalPrice);}group.TotalPrice = group?.DateGroups?.linq?.sum((s) => s?.TotalPrice);}
Domain.Order.setGroups($this, groups);
}
static GetActiveOrder(): any{let user = Joove.Common.cast(window._context.currentUser, "Domain.UserAcount");
if (user == null) {return null;}
if (user?.ActiveOrder == null) {Domain.UserAcount.setActiveOrder(user, new Domain.Order());Domain.Order.setCreatedBy(user.ActiveOrder, user);user.ActiveOrder.OrderStatus = Domain.OrderStatus.New;Domain.Order.setorderToPayment(user.ActiveOrder, new Domain.Payment());user.ActiveOrder.Date = moment().toDate();}
return user?.ActiveOrder;
}
static UpdateTotalPrice($this: any): any{Domain.Order.setDateSections($this, $this?.DateSections?.linq?.orderBy((d) => d?.Date)?.toArray());
for (let _isection = 0; _isection < ($this?.DateSections == null ? 0 : $this?.DateSections.length); _isection++) {let section = $this?.DateSections[_isection];section?.StudentSections?.linq?.orderByDescending((s) => s?.Student?.FullName)?.toArray();Domain.OrderDateSection.UpdateTotalPrice(section);}
$this.orderToPayment.Amount = $this?.DateSections?.linq?.sum((s) => s?.TotalPrice);
Domain.Order.CreateDTO($this);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}